export enum LanguagesCodes {
  En = 'en',
  Es = 'es',
  Pr = 'pr',
  He = 'he',
  De = 'de',
  // Ru = 'ru',
}

export enum LanguageDirection {
  RTL = 'rtl',
  LTR = 'ltr',
}
